import React, { useState, useEffect } from 'react';
import './RefundModal.css';
import { toast } from 'react-toastify';
import axios from 'axios';
import { getSingleTrancheData } from '../../../redux/TrancheReducer/action';
import { useDispatch } from 'react-redux';
import { getAuthToken } from "../../../utils/auth";

const RefundModal = ({ isOpen, onClose, excessDetails, financialSummaryDetails, getTrancheFinancialSummary }) => {
    // excessDetails contains: amount (e.g. "₹62,530.00"), utr, qmsTask, etc.
    const maxAmountRaw = financialSummaryDetails?.pending_excess_amount ? parseFloat(String(financialSummaryDetails.pending_excess_amount).replace(/[^0-9.-]+/g, "")) : 0;

    const [refundAmountInput, setRefundAmountInput] = useState(
        maxAmountRaw.toFixed(2)
    );

    const [refundLoading, setRefundLoading] = useState(false);

    const [refundFormData, setRefundFormData] = useState({
        tranche_id: excessDetails?.tranche_id,
        payment_date: new Date().toISOString().split("T")[0],
        amount: maxAmountRaw,
        mode_of_payment: "UPI",
        transfer_reference_id: "",
        comments: ""
    });

    // const tokens = JSON.parse(sessionStorage.getItem("tokens")) || null;
    // const authToken = tokens?.token || null;
    const authToken = getAuthToken();
    const dispatch = useDispatch();

    useEffect(() => {
        if(isOpen && excessDetails?.is_approved){
            setRefundFormData({
                tranche_id: excessDetails?.tranche_id,
                payment_date: new Date().toISOString().split("T")[0],
                amount: maxAmountRaw,
                mode_of_payment: "UPI",
                transfer_reference_id: "",
                comments: ""
            })
        }
    }, [excessDetails, isOpen]);

    useEffect(() => {
        setRefundAmountInput(maxAmountRaw.toFixed(2));
    }, [maxAmountRaw]);

    if (!isOpen) return null;

    const remainingExcess = maxAmountRaw - (parseFloat(refundFormData?.amount) || 0);

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR',
        }).format(amount);
    };

    const handleConfirm = async () => {
        console.log({
            refundFormData,
            remainingExcess
        });

        let headers = {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${authToken}`
        }

        setRefundLoading(true);

        try {
            let response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/payment_allocations/refund-excess-amount`, 
            {
                ...refundFormData,
                comments: refundFormData?.comments?.trim()
            }, { headers });

            if(response?.data?.status){
                toast.success(`${response?.data?.data?.message}`);
                onClose();

                getTrancheFinancialSummary();

                dispatch(getSingleTrancheData(financialSummaryDetails?.tranche_id));
            }
        } catch (error) {
            toast.error(`${error?.response?.data?.message}`);
        }
        finally {
            setRefundLoading(false);
        }
    };

    return (
        <div className="faux-viewport" onClick={onClose}>
            <div className="modal" onClick={(e) => e.stopPropagation()}>

                <div className="modal-header">
                    <div className="modal-title">
                        <i className="ti ti-arrow-back-up" style={{ fontSize: '16px', color: '#185FA5' }}></i>
                        Record refund
                    </div>
                    <button className="modal-close" onClick={onClose}>
                        <i className="ti ti-x" style={{ fontSize: '15px' }}></i>
                    </button>
                </div>

                <div className="modal-body">
                    <div className="refund-step-tabs">
                        <div className="refund-step active">
                            {/* <div className="refund-step-num">
                                <i className="ti ti-check" style={{ fontSize: '11px' }}></i>
                            </div> */}
                            <div 
                                className="refund-step-num"
                                // style={{
                                //     backgroundColor: "green",
                                //     color: "white"
                                // }}
                            >
                                1
                            </div>
                            QMS approved
                        </div>
                        <div className="refund-step-line"></div>
                        <div className="refund-step active">
                            <div className="refund-step-num">2</div>
                            Enter refund details
                        </div>
                        <div className="refund-step-line"></div>
                        <div className="refund-step">
                            <div className="refund-step-num">3</div>
                            Confirm
                        </div>
                    </div>

                    <div className="info-strip">
                        <div className="info-strip-item">
                            <label>Total excess</label>
                            <span style={{ color: '#185FA5' }}>{financialSummaryDetails?.pending_excess_amount }</span>
                        </div>
                        {/* <div className="info-strip-item">
                            <label>Source UTR</label>
                            <span style={{ fontFamily: 'var(--font-mono, monospace)', fontSize: '12px' }}>{excessDetails?.utr}</span>
                        </div> */}
                        <div className="info-strip-item">
                            <label>QMS task</label>
                            <span style={{ color: '#3B6D11' }}>{excessDetails?.readable_task_id} ✓</span>
                        </div>
                    </div>

                    <div className="form-grid">
                        <div className="field full">
                            <label>Refund amount</label>
                            {/* <input
                                className="amount-big"
                                type="text"
                                inputMode="decimal"
                                min={0}
                                max={maxAmountRaw}
                                value={
                                    refundAmountInput
                                        ? new Intl.NumberFormat("en-IN", {
                                            style: "currency",
                                            currency: "INR",
                                            maximumFractionDigits: 2,
                                        }).format(refundAmountInput)
                                        : ""
                                }
                                onChange={(e) => {
                                    let rawValue = e.target.value.replace(/[^\d.]/g, "");

                                    // allow only one decimal point
                                    const parts = rawValue.split(".");
                                    if (parts.length > 2) return;

                                    // allow empty state while typing
                                    if (rawValue === "") {
                                        setRefundAmountInput("");

                                        setRefundFormData((prev) => ({
                                            ...prev,
                                            amount: 0
                                        }));

                                        return;
                                    }

                                    const numericValue = parseFloat(rawValue);

                                    // prevent invalid numbers
                                    if (isNaN(numericValue)) return;

                                    // prevent values above max limit
                                    if (numericValue > maxAmountRaw) return;

                                    // prevent negative values
                                    if (numericValue < 0) return;

                                    setRefundAmountInput(rawValue);

                                    setRefundFormData((prev) => ({
                                        ...prev,
                                        amount: numericValue
                                    }));
                                }}
                            /> */}

                            <input
                                className="amount-big"
                                type="text"
                                inputMode="decimal"
                                value={refundAmountInput}
                                onChange={(e) => {

                                    let rawValue = e.target.value;

                                    // Allow complete clearing using backspace
                                    if (rawValue === "") {

                                        setRefundAmountInput("");

                                        setRefundFormData((prev) => ({
                                            ...prev,
                                            amount: ""
                                        }));

                                        return;
                                    }

                                    // Remove invalid chars
                                    rawValue = rawValue.replace(/[^\d.]/g, "");

                                    // Prevent multiple decimal points
                                    const decimalCount =
                                        (rawValue.match(/\./g) || []).length;

                                    if (decimalCount > 1) return;

                                    // Prevent more than 2 decimal digits
                                    if (
                                        rawValue.includes(".")
                                    ) {

                                        const decimalPart =
                                            rawValue.split(".")[1];

                                        if (decimalPart.length > 2) {
                                            return;
                                        }
                                    }

                                    // Allow typing like:
                                    // 12.
                                    // 0.
                                    // without auto parse issues
                                    setRefundAmountInput(rawValue);

                                    const numericValue =
                                        parseFloat(rawValue);

                                    // Skip validation till valid number forms
                                    if (isNaN(numericValue)) {
                                        return;
                                    }

                                    // Prevent negative
                                    if (numericValue < 0) {
                                        return;
                                    }

                                    // Prevent more than max amount
                                    if (numericValue > maxAmountRaw) {
                                        return;
                                    }

                                    setRefundFormData((prev) => ({
                                        ...prev,
                                        amount: numericValue
                                    }));
                                }}

                                onBlur={() => {

                                    // Auto format to 2 decimals
                                    if (
                                        refundAmountInput !== "" &&
                                        !isNaN(refundAmountInput)
                                    ) {

                                        const formatted =
                                            Number(refundAmountInput)
                                            .toFixed(2);

                                        setRefundAmountInput(formatted);

                                        setRefundFormData((prev) => ({
                                            ...prev,
                                            amount: Number(formatted)
                                        }));
                                    }
                                }}
                            />
                            <div 
                                style={{ 
                                    fontSize: '11px', 
                                    color: 'var(--color-text-tertiary, #64748B)', 
                                    marginTop: '4px' 
                                }}
                            >
                                Max refundable: {financialSummaryDetails?.pending_excess_amount} · Leave as-is for full refund, or edit for partial
                            </div>
                        </div>

                        <div className="field">
                            <label>Mode of refund</label>
                            <select 
                                value={refundFormData?.mode_of_payment} 
                                onChange={(e) => {
                                    setRefundFormData({
                                        ...refundFormData,
                                        mode_of_payment: e.target.value
                                    })
                                }}
                            >
                                <option value="NEFT">NEFT</option>
                                <option value="IMPS">IMPS</option>
                                <option value="UPI">UPI</option>
                                <option value="RTGS">RTGS</option>
                                <option value="Cheque">Cheque</option>
                            </select>
                        </div>

                        <div className="field">
                            <label>Refund date</label>
                            <input
                                type="date"
                                // value={refundDate.toISOString().split('T')[0]}
                                value={refundFormData.payment_date}
                                max={new Date().toISOString().split('T')[0]}
                                onChange={(e) => {
                                    setRefundFormData({
                                        ...refundFormData,
                                        payment_date: e.target.value
                                    })
                                }}
                                className="refund-calendar"
                            />
                        </div>

                        <div className="field full">
                            <label>Transaction reference number</label>
                            <input
                                type="text"
                                placeholder="Bank UTR / ref number"
                                value={refundFormData.transfer_reference_id}
                                onChange={(e) => {
                                    // Remove spaces + special characters
                                    const sanitizedValue = e.target.value.replace(/[^a-zA-Z0-9]/g, '');

                                    setRefundFormData({
                                        ...refundFormData,
                                        transfer_reference_id: sanitizedValue
                                    })
                                }}
                            />
                        </div>

                        <div className="field full">
                            <label>
                                Comments 
                                {/* <span 
                                    style={{ 
                                        color: 'var(--color-text-tertiary, #64748B)' 
                                    }}
                                >
                                    (optional)
                                </span> */}
                            </label>
                            <textarea
                                placeholder="e.g. Customer confirmed bank account via call on 24 May"
                                maxLength={50}
                                value={refundFormData.comments}
                                onChange={(e) => {

                                    // Remove special chars
                                    let sanitizedValue = e.target.value.replace(/[^a-zA-Z0-9 ]/g, '');

                                    // Trim starting spaces
                                    sanitizedValue = sanitizedValue.replace(/^\s+/, '');

                                    // Replace multiple spaces with single space
                                    sanitizedValue = sanitizedValue.replace(/\s{2,}/g, ' ');

                                    setRefundFormData({
                                        ...refundFormData,
                                        comments: sanitizedValue
                                    })
                                }}
                            />

                            <div className="char-counter">
                                {
                                    50 -
                                    (refundFormData.comments?.length || 0)
                                } characters left
                            </div>

                            {
                                refundFormData.comments &&
                                refundFormData.comments.trim().length < 5 && (
                                    <div className="error-text">
                                        Minimum 5 characters required
                                    </div>
                                )
                            }
                        </div>
                    </div>

                    <div className="summary-confirm">
                        <div className="summary-row-item">
                            <span style={{ color: 'var(--color-text-secondary, #475569)' }}>Total excess</span>
                            <span>{excessDetails?.amount}</span>
                        </div>
                        <div className="summary-row-item">
                            <span style={{ color: 'var(--color-text-secondary, #475569)' }}>Refund amount</span>
                            <span style={{ color: '#185FA5' }}>{formatCurrency(refundFormData?.amount || 0)}</span>
                        </div>
                        <div className="summary-row-item">
                            <span style={{ color: 'var(--color-text-secondary, #475569)' }}>Remaining excess after refund</span>
                            <span style={{ color: '#3B6D11' }}>{formatCurrency(remainingExcess)}</span>
                        </div>
                    </div>
                </div>

                <div className="modal-footer">
                    <button className="refund-btn" onClick={onClose}>Cancel</button>
                    <button 
                        className="refund-btn refund-btn-primary" 
                        onClick={handleConfirm}
                        disabled={refundLoading}
                    >
                        <i className="ti ti-check" style={{ fontSize: '13px' }}></i> Confirm refund
                    </button>
                </div>
            </div>
        </div>
    );
};

export default RefundModal;